import { createSelector } from '@reduxjs/toolkit';
import { settingEntity } from 'src/enums/settings';
import i18n from 'i18next';
import translations from 'src/internationalisation/translation-map.json';
import type { TRootState } from 'src/store/store-types';

const selectTemplates = (state: TRootState) => state.entities.templates;

export const selectUserTemplates = createSelector([selectTemplates], (templates) => templates.userTemplates);

export const selectCompanyTemplates = createSelector([selectTemplates], (templates) => templates.companyTemplates);

export const selectIsAddingTemplates = createSelector([selectTemplates], (templates) => templates.isAdding || false);

export const selectIsFetchingTemplates = createSelector(
  [selectTemplates],
  (templates) => templates.isFetching || false,
);

export const selectTemplatesFormVisibility = createSelector(
  [selectTemplates],
  ({ showTemplatesForm, showOperationsForm, showActivityForm }) => ({
    showTemplatesForm,
    showOperationsForm,
    showActivityForm,
  }),
);

export const selectTemplatesModalVisibility = createSelector(
  [selectTemplates],
  ({
    showDeleteOperationsModal,
    showDeleteActivitiesModal,
    showDeleteCostItemModal,
    showImportOperationModal,
    showDeleteCostCategoryModal,
  }) => ({
    showDeleteOperationsModal,
    showDeleteActivitiesModal,
    showDeleteCostItemModal,
    showImportOperationModal,
    showDeleteCostCategoryModal,
  }),
);

export const selectSectionTypes = createSelector([selectTemplates], (templates) => templates.sectionTypes);

export const selectActiveSection = createSelector(
  [selectSectionTypes],
  (sectionTypes) => sectionTypes.find((item) => item.active) || null,
);

export const getSelectedId = createSelector([selectTemplates], (templates) => templates.selectedId);

export const selectTemplateOptions = createSelector(
  [selectUserTemplates, selectCompanyTemplates],
  (userTemplates, companyTemplates) => [
    {
      label: i18n.t(translations.userRulesets),
      type: 'Heading',
    },
    ...userTemplates.map((template, idx) => ({
      label: template.highLevel.name,
      value: `${settingEntity.USER}-${idx}`,
    })),
    {
      label: i18n.t(translations.companyRulesets),
      type: 'Heading',
    },
    ...companyTemplates?.map((template, idx) => ({
      label: template.highLevel.name,
      value: `${settingEntity.COMPANY}-${idx}`,
    })),
  ],
);
